<template>
  <div>
    {{ $t('FE_GENERIC_ERROR') }}
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
div {
  color: $deprecated-color-ui-error;

  @include font('050');
}
</style>
